import ProductsIndex from '../views/products/ViewAllProducts';
import Product from '../views/products/Product';

import Constants from './Constants';


export default [
    {
        path : '/products/',
        name : Constants.PRODUCTS_INDEX,
        component : ProductsIndex,
        meta : {
            title : 'Products',
            accessGuard : true,
        }
    },
    {
        path : '/products/:id',
        name : Constants.PRODUCTS_VIEW,
        component : Product,
        meta : {
            title : 'Product',
            accessGuard : true,
        },
    },
];
